exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".builder-logo[data-v-08468b06]{max-height:40px}#nav[data-v-08468b06]{height:64px}.mobile-nav[data-v-08468b06]{width:250px}@media (max-width:575px){.builder-logo[data-v-08468b06]{max-height:30px}.v-btn[data-v-08468b06]{font-size:12px;padding:0 12px}}@media (max-width:450px){.builder-logo[data-v-08468b06]{max-height:20px}.v-toolbar__title[data-v-08468b06]:not(:first-child){margin-left:0}.v-btn[data-v-08468b06]{font-size:10px;padding:0 8px;min-width:auto}}", ""]);

// exports
